module.exports = __webpack_public_path__ + "static/media/1.1_preview.cbb0a0f9.png";